export const SETTINGS_MODAL_INTERACTION_DELAY = 400;
